import { getCompanyLogo } from 'lib/api/company';
import { expressGetCompanyLogo } from 'lib/api/express';
import { getCompanyPayoutGroup } from 'lib/api/payments';
import { showAlert } from 'lib/functions/utils';
import { Dispatch } from 'redux';

import { generateSimulationPDF } from '../../exportSimulation';
import { ExportCheckboxesState } from '../hooks/useExportCheckboxes';

export interface ExportSimulationOptions {
  dispatch: Dispatch;
  user: any;
  request: any;
  checkboxes: ExportCheckboxesState;
  includePayouts?: boolean;
  canShowPayouts?: boolean;
}

export const handleExportSimulation = async (
  options: ExportSimulationOptions,
): Promise<void> => {
  const {
    dispatch,
    user,
    request,
    checkboxes,
    includePayouts = false,
    canShowPayouts = false,
  } = options;

  try {
    // Obtener payouts si es necesario
    const payouts =
      includePayouts && canShowPayouts && checkboxes.showPayouts
        ? await getCompanyPayoutGroup(dispatch, 'factoring-request', request.id)
        : null;

    // Obtener logo
    const imageBase64 = user?.express
      ? await expressGetCompanyLogo(dispatch, user.clientId as string)
      : await getCompanyLogo(dispatch);

    // Generar PDF
    await generateSimulationPDF(
      request,
      user?.name || '',
      imageBase64,
      payouts,
    );

    showAlert(dispatch, 'success', 'Simulación exportada correctamente');
  } catch (error) {
    console.error(error);
    showAlert(dispatch, 'error', 'Error al exportar simulación');
    throw error;
  }
};
